import { render, staticRenderFns } from "./OpenStatusChange.vue?vue&type=template&id=46ccb810&scoped=true&"
import script from "./OpenStatusChange.vue?vue&type=script&lang=js&"
export * from "./OpenStatusChange.vue?vue&type=script&lang=js&"
import style0 from "./OpenStatusChange.vue?vue&type=style&index=0&id=46ccb810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ccb810",
  null
  
)

export default component.exports